import { useEffect, useMemo } from 'react'
import clsx from 'clsx'
import { loadStaticFromPublic } from 'common/utils'

import { ClientLogo } from '../logo'

import classes from './styles.module.css'

export default function MissingLocales() {
  const currentLang = useMemo(() => {
    return localStorage.getItem('i18nextLng') || 'pl'
  }, [])

  const isPolishLanguage = useMemo(() => {
    return currentLang === 'pl'
  }, [currentLang])

  useEffect(() => {
    document.title = 'Xelto apps'
  }, [])

  return (
    <div
      className={
        'fixed top-0 left-0 z-[9999] flex items-center justify-center w-screen h-screen'
      }
    >
      <div className={'flex flex-col items-center mx-4'}>
        <ClientLogo height={145} logoUrl={loadStaticFromPublic('xelto-apps-logo.jpg')} />
        <h1 className={clsx('text-zinc-800 my-8', classes.title)}>{'Oops!'}</h1>
        {isPolishLanguage ? (
          <p className={clsx('text-zinc-900 my-0 text-center', classes.mainText)}>
            {`Wystąpił problem z załadowaniem tłumaczeń do aplikacji`}
            <br />
            <span>{'Proszę odświeżyć stronę i spróbować ponownie'}</span>
          </p>
        ) : (
          <p className={clsx('text-zinc-500 mt-0 text-center', classes.secondText)}>
            {'There was a problem loading translations into the application'}
            <br />
            <span>{'Reload page and try again, please'}</span>
          </p>
        )}
      </div>
    </div>
  )
}
